import PrivacyPolicyComponent from "components/PrivacyPolicy"
import { Suspense } from "react"

const PrivacyPolicy = ({ canonical }) => <Suspense fallback={<div>Loading...</div>}>
  <PrivacyPolicyComponent canonical={canonical} />
</Suspense>

export default PrivacyPolicy
